import { observer } from 'mobx-react-lite';
import { useSocials } from 'hooks';
import { formatPhoneByLength } from 'utils';
import { IPhone } from 'types';
import { HStack } from 'components';
import { SVG } from 'components/svg';
import { Button, Hint, message } from 'components/ui';
import { Icons } from 'assets';
import { copyToClipboard } from '../ui/utils';

type SocialsButtonGroupProps = {
  phone: IPhone;
  onDelete?: () => void;
  deletePending?: boolean;
  withoutSocials?: boolean;
};

export const SocialsButtonGroup = observer(
  ({
    phone,
    onDelete,
    deletePending,
    withoutSocials,
  }: SocialsButtonGroupProps) => {
    const fullPhone = !phone.code ? phone.number : phone.code + phone.number;
    const { socials, toggle } = useSocials(fullPhone);
    const isFetching = !socials || socials.fetch.pending;

    const handleCopy = () => {
      if (!fullPhone) {
        return message({ type: 'error', text: 'Не удалось скопировать' });
      }

      copyToClipboard(`+7${fullPhone}`, undefined, {
        success: 'Номер телефона скопирован',
        error: 'Не удалось скопировать',
      });
    };

    return (
      <HStack spacing="xs">
        <Button.Group size="s" mode="neutral" variant="minor">
          <Button>{formatPhoneByLength(fullPhone)}</Button>

          <Hint content="Скопировать">
            <Button
              iconButton={<SVG src={Icons.Clone} />}
              onClick={handleCopy}
            />
          </Hint>

          {!withoutSocials && (
            <>
              <Button
                pending={isFetching}
                selected={socials?.max}
                onClick={() => toggle('max')}
                iconButton={<SVG src={Icons.MaxLogo} />}
              />
              <Button
                pending={isFetching}
                selected={socials?.vkontakte}
                onClick={() => toggle('vkontakte')}
                iconButton={<SVG src={Icons.VK} complex />}
              />
              <Button
                pending={isFetching}
                selected={socials?.odnoklassniki}
                onClick={() => toggle('odnoklassniki')}
                iconButton={<SVG src={Icons.OKLogo} complex />}
              />
              <Button
                pending={isFetching}
                selected={socials?.telegram}
                onClick={() => toggle('telegram')}
                iconButton={<SVG src={Icons.TelegramSquaredLogo} complex />}
              />
            </>
          )}
        </Button.Group>

        <Hint
          content={'Должен остаться хотя бы один\nномер телефона'}
          enabled={!onDelete}
        >
          <Button
            mode="error"
            size="s"
            pending={deletePending}
            disabled={!onDelete}
            onClick={onDelete}
          >
            Удалить
          </Button>
        </Hint>
      </HStack>
    );
  }
);
